<template>
  <div>
    <div
        ref="langDropdown"
        :class="{
          '!px-0 md:!px-3': footer,
        }"
        class="relative z-50 flex gap-1 cursor-pointer items-center rounded-full px-3 md:max-h-auto md:py-2"
        @click="toggleExpanded"
    >
      <BaseIcon :class="{'!text-neutral-700': dark, '!text-neutral-500': grey}" class="h-4 w-4 text-white m-1" filled name="globe"/>
      <p
          :key="activeLocale.code"
          :class="{
            '!text-neutral-700' : dark,
            '!text-neutral-500': grey,
            '!capitalize': !utils.isMobile,
            'font-regular': utils.isMobile,
           }"
          class="mr-1 uppercase text-white transition hover:text-purple"
      >{{ utils.isMobile ? activeLocale.code : activeLocale.name }}
      </p>
      <Transition
        enter-active-class="transition-opacity duration-200 ease-out"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition-opacity duration-150 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div v-show="active"
             :class="{
              '!bg-neutral-900/30 !backdrop-blur-xl !text-white': darkMenu,
              'bottom-full mb-2 left-0 md:right-0': inverse,
              'top-full mt-2 right-0': !inverse,
             }"
             class="absolute flex flex-col items-center rounded-lg bg-white px-2 py-2 font-normal shadow-lg min-w-max">
          <NuxtLink
              v-for="locale in locales"
              :key="locale.code"
              :class="{
                'hover:!bg-neutral-200': !darkMenu
              }"
              :to="switchLocalePath(locale.code)"
              class="flex items-center w-full px-2 py-2 transition hover:rounded hover:bg-neutral-200/30"
              @click="updateLocale(locale.code)"
          >
            <span :class="{'text-neutral-700': !darkMenu}">{{ locale.name }}</span>
            <BaseIcon v-if="locale.code === activeLocale.code" :class="{'!text-neutral-500' : !darkMenu}"
                      class="h-4 w-4 text-white ml-1" filled name="check"/>
            <div v-if="locale.code !== activeLocale.code" class="h-4 w-4 ml-1"></div>
          </NuxtLink>
        </div>
      </Transition>

      <BaseIcon :class="{'!text-neutral-500' : dark || grey, '-rotate-90': footer ? !active : active, 'rotate-90': footer ? active : !active }" class="h-4 w-4 text-white" filled name="chevron"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {onClickOutside} from "@vueuse/core"
import {useUtilStore} from "~/store/util"

defineProps({
  dark: {
    type: Boolean,
    default: false
  },
  darkMenu: {
    type: Boolean,
    default: false
  },
  expanded: {
    type: Boolean,
    default: false
  },
  grey: {
    type: Boolean,
    default: false
  },
  inverse: {
    type: Boolean,
    default: false
  },
  footer: {
    type: Boolean,
    default: false
  }
})

const switchLocalePath = useSwitchLocalePath()
const {locales, localeProperties: activeLocale} = useI18n()
const utils = useUtilStore()

const langDropdown = ref(null)
const active = ref(false)
const isNavigating = ref(false)

onClickOutside(langDropdown, () => active.value = false)

function toggleExpanded() {
  if (!isNavigating.value) {
    active.value = !active.value
  }
}

async function updateLocale(code: string) {
  isNavigating.value = true
  active.value = false;

  setTimeout(() => {
    const dayjs = useDayjs()
    dayjs.locale(code)

    useHead({
      htmlAttrs: {
        lang: code
      }
    });

    utils.hasSetEventLang = true
    isNavigating.value = false
  }, 5)
}
</script>
